/**
 * VolumeSlider Component - Range input for adjusting row volume
 * Provides volume control from 0.0 to 1.0
 */

/**
 * Props for VolumeSlider component
 */
interface VolumeSliderProps {
  /** Current volume value (0.0 - 1.0) */
  value: number;
  /** Callback when volume changes */
  onChange: (volume: number) => void;
  /** Row index for accessibility */
  row: number;
}

/**
 * VolumeSlider component
 * Renders a range input for volume control
 * 
 * @param props - Component props
 * @returns VolumeSlider component
 */
export function VolumeSlider({ value, onChange, row }: VolumeSliderProps) {
  /**
   * Handle input change
   */
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newVolume = parseFloat(e.target.value);
    onChange(newVolume);
  };

  return (
    <input
      type="range"
      className="volume-slider w-[60px]"
      min="0"
      max="1"
      step="0.01"
      value={value}
      onChange={handleChange}
      aria-label={`Volume for row ${row + 1}`}
      aria-valuemin={0}
      aria-valuemax={1}
      aria-valuenow={value}
      aria-valuetext={`${Math.round(value * 100)}%`}
      title={`Volume: ${Math.round(value * 100)}%`}
    />
  );
}
